import {createDocumentScopedValue, readDocumentScopedValue} from './landViewDocumentState'

const LAND_SECTION_BY_LAND_STORAGE_KEY = 'specific:view-land-section-by-land'
export const DEFAULT_LAND_SECTION = 'images'

export const normalizeLandSection = (section) => {
  if (section === 'ambients' || section === 'layers' || section === 'comparison') {
    return section
  }

  return DEFAULT_LAND_SECTION
}

const getSessionStorage = () => {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    return window.sessionStorage || null
  } catch (error) {
    return null
  }
}

const getStoredLandSections = () => {
  const storage = getSessionStorage()

  if (!storage) {
    return {}
  }

  try {
    const rawValue = storage.getItem(LAND_SECTION_BY_LAND_STORAGE_KEY)
    const parsed = readDocumentScopedValue(rawValue ? JSON.parse(rawValue) : null) || {}

    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {}
  } catch (error) {
    return {}
  }
}

export const getLastLandSection = (landId) => {
  if (!landId) {
    return DEFAULT_LAND_SECTION
  }

  return normalizeLandSection(getStoredLandSections()[landId])
}

export const hasLastLandSection = (landId) => {
  if (!landId) {
    return false
  }

  return Object.prototype.hasOwnProperty.call(getStoredLandSections(), landId)
}

export const setLastLandSection = (landId, section) => {
  if (!landId) {
    return
  }

  const storage = getSessionStorage()

  if (!storage) {
    return
  }

  try {
    storage.setItem(
      LAND_SECTION_BY_LAND_STORAGE_KEY,
      JSON.stringify(
        createDocumentScopedValue({
          ...getStoredLandSections(),
          [landId]: normalizeLandSection(section),
        })
      )
    )
  } catch (error) {
    // Session storage can be unavailable in restricted browser modes.
  }
}
